import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { DocumentationRating } from '../reference/documentation-rating.js';
import { DailyReportEntry, DailyReportEntryTypes } from './daily-report-entry.js';
export const DocumentationEntry = Type.Evaluate(Type.Intersect([
    DailyReportEntry,
    Type.Object({
        typeName: Type.Literal(DailyReportEntryTypes.documentation),
        pendingApproval: Type.Optional(Type.Boolean()),
        documentationId: Type.Optional(Type.String({ minLength: 1 })),
        observationId: Type.Optional(Type.String({ minLength: 1 })),
        status: Type.String({ minLength: 1 }),
        attachments: Type.Optional(Type.Array(Attachment)),
        childKeys: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        dimensionIds: Type.Optional(Type.Array(Type.String({ minLength: 1 }))),
        ratings: Type.Optional(Type.Array(DocumentationRating))
    })
]));
